import { Injectable } from '@angular/core';

type CleanupFn = () => void;

@Injectable({
  providedIn: 'root',
})
export class StateCleanupService {
  private cleanupFns = new Set<CleanupFn>();

  register(fn: CleanupFn) {
    this.cleanupFns.add(fn);
  }

  clearAll() {
    this.cleanupFns.forEach((fn) => {
      try {
        fn();
      } catch (error) {
        console.error('State cleanup failed', error);
      }
    });
  }
}
